<template>
  <v-text-field
    ref="inputRef"
    v-bind="$attrs"
    :disabled="disabled"
  >
    <template v-slot:append>
      <slot name="append" />
    </template>
  </v-text-field>
</template>

<script>
import { useCurrencyInput } from 'vue-currency-input'
import { watch } from '@vue/composition-api'

export default {
  name: 'CurrencyInput',
  props: {
    value: {
      type: [Number, String],
      default: undefined
    },
    options: {
      type: Object,
      default: () => undefined
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const { inputRef, setValue, numberValue } = useCurrencyInput(props.options)

    watch(
      () => props.value, // Vue 2: props.value
      (value) => {
        setValue(value)
      }
    )

    watch(
      () => numberValue.value,
      (newValue) => {
        emit('input', newValue)
      }
    )

    return { inputRef }
  }
}
</script>
